var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 12,
    viewBox: "0 0 254 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 87",
    x: 0.463867,
    y: 0.121094,
    width: 253.536,
    height: 11.836,
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 88",
    x: 0.963867,
    y: 0.621094,
    width: 252.536,
    height: 10.836,
    fill: "#00364A",
    stroke: "#E1E1E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.3b77892acb669b21816a82f3123ec06b.svg";
export { ForwardRef as ReactComponent };